import type { FunctionComponent } from "react";

import { HomepageAiPlaceholder } from "~/components/home/placeholder/ai-placeholder";
import { HomepageAroundScmpPlaceholder } from "~/components/home/placeholder/around-scmp-placeholder";
import { HomepageFromOurAdvertisersPlaceholder } from "~/components/home/placeholder/from-our-advertisers-placeholder";
import { HomepageMostPopularPlaceholder } from "~/components/home/placeholder/most-popular-placeholder";
import { HomepageMultimediaPlaceholder } from "~/components/home/placeholder/multimedia-placeholder";
import { HomepageMyNewsPlaceholder } from "~/components/home/placeholder/my-news-placeholder";
import { HomepageSectionPlaceholder } from "~/components/home/placeholder/section-placeholder";
import { HomepageSubscriptionPlaceholder } from "~/components/home/placeholder/subscription-placeholder";
import {
  AroundScmp,
  FifthSectionBlock,
  FirstSectionBlock,
  FourthSectionBlock,
  FromOurAdvertisers,
  MostPopular,
  Multimedia,
  MyNews,
  RecommendedForYou,
  SecondSectionBlock,
  Subscription,
  ThirdSectionBlock,
  YouMayHaveMissed,
} from "~/pages/home/styles";

export { DesktopContainer, MobileContainer, TabletContainer } from "./styles";

export const HomepageClientQueryPlaceholder: FunctionComponent = () => (
  <>
    <Multimedia>
      <HomepageMultimediaPlaceholder />
    </Multimedia>
    <RecommendedForYou>
      <HomepageAiPlaceholder />
    </RecommendedForYou>
    <FirstSectionBlock>
      <HomepageSectionPlaceholder />
    </FirstSectionBlock>
    <Subscription>
      <HomepageSubscriptionPlaceholder />
    </Subscription>
    <SecondSectionBlock>
      <HomepageSectionPlaceholder />
    </SecondSectionBlock>
    <YouMayHaveMissed>
      <HomepageAiPlaceholder />
    </YouMayHaveMissed>
    <MyNews>
      <HomepageMyNewsPlaceholder />
    </MyNews>
    <ThirdSectionBlock>
      <HomepageSectionPlaceholder />
    </ThirdSectionBlock>
    <FourthSectionBlock>
      <HomepageSectionPlaceholder />
    </FourthSectionBlock>
    <FifthSectionBlock>
      <HomepageSectionPlaceholder />
    </FifthSectionBlock>
    <MostPopular>
      <HomepageMostPopularPlaceholder />
    </MostPopular>
    <FromOurAdvertisers>
      <HomepageFromOurAdvertisersPlaceholder />
    </FromOurAdvertisers>
    <AroundScmp>
      <HomepageAroundScmpPlaceholder />
    </AroundScmp>
  </>
);

HomepageClientQueryPlaceholder.displayName = "HomepageClientQueryPlaceholder";
